import { filter } from 'lodash';
import Term from '../Term';
import Range from '../Range';

import { TYPE_ARRAY, TYPE_TERM } from '../constants';

function markTermRanges(term, ranges, rangesFiltered) {
  if (Array.isArray(term)) {
    // eslint-disable-next-line no-use-before-define
    markRanges(term, ranges);
  } else {
    if (!((term instanceof Term))) {
      throw new Error('markTermRanges expects a term');
    }

    if (!(Array.isArray(ranges))) {
      throw new Error('markTermRanges expects an array of ranges');
    }

    const lRanges = rangesFiltered ? ranges : filter(ranges, range => range instanceof Range && range.isValid);
    let found = false;

    if (term.isValidTime) {
      lRanges.forEach((range) => {
        if (range.intersects(term) || (term.start <= range.start && term.end >= range.start) ) {
          term.set(`range:${range.name}`, true);
          found = true;
        }
      });
      if (!found) return;
    }

    switch (term.type) {
      case TYPE_TERM:
        markTermRanges(term.value, lRanges, true);
        break;

      case TYPE_ARRAY:
        // eslint-disable-next-line no-use-before-define
        markRanges(term.value, lRanges, true);
        break;

      default:
      // not a recursing term
    }
  }
}

/**
 * markRanges changes the properties of the input - it doesn't create/rearrange terms.
 *
 * It goes through each range and if the term contains the range, it marks it.
 * Note it is a recursive operation - it marks any container that falls in a range, AND
 * it goes through the children and marks them too.
 *
 * @param source {Array || Term}
 * @param ranges {[Range]}
 * @returns void
 */
export default function markRanges(source, ranges) {
  if (!((Array.isArray(source) || (source instanceof Term)))) {
    throw new Error('markRanges expects source to be a term and an array');
  }
  if (!Array.isArray(ranges)) {
    throw new Error('markRanges expects ranges to be an array');
  }
  const lRanges = filter(ranges, range => range instanceof Range && range.isValid);

  if (source instanceof Term) {
    markTermRanges(source, lRanges, true);
  } else {
    source.forEach((term) => {
      switch (Term.typeOf(term)) {
        case TYPE_ARRAY:
          markRanges(term, lRanges);
          break;

        case TYPE_TERM:
          markTermRanges(term, lRanges, true);
          break;

        default:
          console.log('unknown type found in markRanges series');
      }
    });
  }
}
